import { Button } from '@mui/material';

const Reward = () => {
  console.log(process.env.VERCEL_ENV);
  return (
    <div>
      Partners
      <br />
      <br />
      <Button variant='contained'>Primary</Button>
      <Button
        color='secondary'
        variant='contained'
        onClick={() => {
          throw new Error('test 4 Sentry Frontend Error');
        }}
      >
        Secondary
      </Button>
    </div>
  );
};

export default Reward;
